module.exports = __webpack_public_path__ + "img/Sahara-group-logo.c339e363.jpg";